import useAppModal from 'hooks/useAppModal';
import { useTranslation } from 'react-i18next';
import MessageLogViewModal from './MessageLogViewModal';

const modalId = 'message-log-view-modal';

const useMessageLogViewModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openViewMessageLogModal = ({
    messageLogUid,
  }: {
    messageLogUid: string;
  }) => {
    openModal({
      customContent: <MessageLogViewModal messageLogUid={messageLogUid} />,
      id: modalId,
      title: t('pageAutomations.messageLog.modal.title'),
    });
  };

  return { openViewMessageLogModal };
};

export default useMessageLogViewModal;
